export default "__VITE_ASSET__f743cafa__"